import './BGrainOverlay.css';

/**
 * Film grain texture overlay that appears over all content
 * for the Record Store Editorial aesthetic.
 */
export function BGrainOverlay() {
  return <div className="b-grain-overlay" aria-hidden="true" />;
}
